import { useState } from "react";
import { Loading } from "../../components/common/Loading";
import { useCategoriesQuery } from "../../services/queryHooks";
import { Button, Typography, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import "./Categories.scss";
import DeleteCategoryGroupModal from "./modals/DeleteCategoryGroupModal";
import AddCategoryGroupModal from "./modals/AddCategoryGroupModal";
import CategoryGroup from "./CategoryGroup";
import { useTranslation } from "react-i18next";

function Categories() {
	const {
		data: categories,
		isPending,
		isError,
		error,
	} = useCategoriesQuery();

	const [deleteConfirmationModalData, setDeleteConfirmationModalData] =
		useState(null);
	const [isAddCategoryModalOpen, setIsAddCategoryModalOpen] = useState(false);
	const { t } = useTranslation();

	const openDeleteGroupModal = (groupData) => {
		setDeleteConfirmationModalData(groupData);
	};
	const getIncomeCategories = () => {
		const incomeCategories = categories.filter(
			(category) => category.type === "income"
		);
		return incomeCategories;
	};
	const getExpenseCategories = () => {
		const expenseCategories = categories.filter(
			(category) => category.type === "expense"
		);
		return expenseCategories;
	};
	if (isPending) {
		return <Loading loadingText={t("loading")} />;
	}
	if (isError) {
		return <span>Error : {error.message}</span>;
	}

	return (
		<>
			<DeleteCategoryGroupModal
				isOpen={deleteConfirmationModalData !== null}
				modalData={deleteConfirmationModalData}
				categories={categories}
				onClose={() => setDeleteConfirmationModalData(null)}
			/>
			<AddCategoryGroupModal
				isOpen={isAddCategoryModalOpen}
				onClose={() => setIsAddCategoryModalOpen(false)}
			/>
			<Box>
				<div className="header">
					<Typography variant="h4" gutterBottom sx={{ mb: 0 }}>
						{t("categories")}
					</Typography>
					<Button
						color="primary"
						variant="contained"
						startIcon={<AddIcon />}
						onClick={() => setIsAddCategoryModalOpen(true)}
						sx={{ py: 0.5, px: 1 }}
					>
						{t("addCategoryGroup")}
					</Button>
				</div>
			</Box>

			<Box
				sx={{
					display: "flex",
					flexWrap: "wrap",
					p: 1,
				}}
			>
				<CategoryGroup
					categoriesType={t("expenses")}
					data={getExpenseCategories()}
					openDeleteGroupModal={openDeleteGroupModal}
				/>
				<CategoryGroup
					categoriesType={t("incomes")}
					data={getIncomeCategories()}
					openDeleteGroupModal={openDeleteGroupModal}
				/>
			</Box>
		</>
	);
}

export default Categories;
